import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getRatioClassName(ratio: string) {
  if (ratio === '1') return 'flex-1';
  else if (ratio === '2') return 'flex-2';
  else if (ratio === '3') return 'flex-3';
  else if (ratio === '4') return 'flex-4';
  else if (ratio === '5') return 'flex-5';
  else if (ratio === '6') return 'flex-6';
  else if (ratio === '7') return 'flex-7';
  else if (ratio === '8') return 'flex-8';
  else return 'flex-1';
}

export function getRatioClassnames(ratio: string | undefined) {
  if (!ratio) return ['flex-1', 'flex-1'];
  const [left, right] = ratio.split(':');
  return [getRatioClassName(left), getRatioClassName(right)];
}
